import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Waves, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navigation = ({ user, onLogout, transparent = false }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all ${
        transparent ? 'glassmorphism' : 'bg-white border-b border-slate-200'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/logo.jpg"
              alt="Streamline Aquatics"
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              Home
            </Link>
            <Link to="/about" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              About
            </Link>
            <Link to="/services" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              Services
            </Link>
            <Link to="/schedules-pricing" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              Pricing
            </Link>
            <Link to="/book-lesson" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              Book Now
            </Link>
            <Link to="/swim-team" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              Marlins Team
            </Link>
            <Link to="/faqs" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              FAQs
            </Link>
            <Link to="/contact" className="text-slate-700 hover:text-cyan-700 font-medium transition-colors">
              Contact
            </Link>
            {user ? (
              <>
                {user.role === 'admin' && (
                  <Link to="/admin">
                    <Button variant="outline" size="sm" data-testid="admin-dashboard-btn">
                      Admin
                    </Button>
                  </Link>
                )}
                <Link to="/member-portal">
                  <Button variant="outline" size="sm" data-testid="member-portal-btn">
                    Portal
                  </Button>
                </Link>
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  size="sm"
                  data-testid="logout-btn"
                  className="text-slate-700"
                >
                  Logout
                </Button>
              </>
            ) : (
              <Link to="/login">
                <Button data-testid="login-btn" className="btn-primary">
                  Login
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3" data-testid="mobile-menu">
            <Link
              to="/"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <Link
              to="/services"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Services
            </Link>
            <Link
              to="/schedules-pricing"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Schedules & Pricing
            </Link>
            <Link
              to="/book-lesson"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Book Now
            </Link>
            <Link
              to="/swim-team"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Marlins Team
            </Link>
            <Link
              to="/faqs"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              FAQs
            </Link>
            <Link
              to="/policies"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Policies
            </Link>
            <Link
              to="/contact"
              className="block py-2 text-slate-700 hover:text-cyan-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>
            {user ? (
              <>
                {user.role === 'admin' && (
                  <Link to="/admin" onClick={() => setIsOpen(false)}>
                    <Button variant="outline" size="sm" className="w-full">
                      Admin Dashboard
                    </Button>
                  </Link>
                )}
                <Link to="/member-portal" onClick={() => setIsOpen(false)}>
                  <Button variant="outline" size="sm" className="w-full">
                    Member Portal
                  </Button>
                </Link>
                <Button onClick={handleLogout} variant="ghost" size="sm" className="w-full">
                  Logout
                </Button>
              </>
            ) : (
              <Link to="/login" onClick={() => setIsOpen(false)}>
                <Button className="btn-primary w-full">Login</Button>
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
